// src/pages/income/business/incomeBusinessDraftConfig.js
// ✅ 수입데이터+수입기안 통합 작성 [파일럿] — 경영팀 사업의 config.
// 종류 4종은 IncomeBusinessIncome 실사용(65건) 근거: 예금 이자수익 35 / 카드매출
// 수수료 환급 18 / 기타영업외수익 9 / 장애인고용장려금 3. DocumentTypeSelector.jsx의
// 기존 DETAIL_OPTIONS["income_draft-경영팀"]("수입보고" 1종)는 실사용과 무관해 채택하지 않음.
import { makeIncomeDraftConfig } from "../_shared/incomeDraftConfig";

const CATEGORIES = [
  { value: "예금 이자수익", label: "예금 이자수익" },
  { value: "카드매출 수수료 환급", label: "카드매출 수수료 환급" },
  { value: "기타영업외수익", label: "기타영업외수익" },
  { value: "장애인고용장려금", label: "장애인고용장려금" },
];

const incomeBusinessDraftConfig = makeIncomeDraftConfig({
  namespace: "income-business-draft",
  category: "경영팀",
  businessLabel: "경영팀",
  tabTitle: "경영팀",
  // ✅ (구) 페이지가 실제로 쓰는 IncomeBusinessIncome.draft_no 접두어와 동일(실측:
  // income_business/views_api.py create()의 "금천일자리(주)경영-").
  draftNoPrefix: "금천일자리(주)경영",
  dataApiBase: "/income/business/",
  combinedCreateApi: "/income/business/draft/",
  newRoutePath: "/income/business/draft/new",
  listRoutePath: "/income/business/draft/list",
  previewRoutePath: "/income/business/draft/preview",
  categories: CATEGORIES,
  // ✅ 경영팀은 income.models.Partner(간이 거래처 모델) 사용 — 용역사업(vendor_app.Vendor)과
  // 다름, 사업별로 다를 수 있어 config로 분리.
  partnerApiBase: "/partners/",
});

export default incomeBusinessDraftConfig;
